import { createSelector } from 'reselect';
import { State } from 'models';
import _orderBy from 'lodash/orderBy';
import get from 'lodash/get';
import { orderByType } from 'utils';

export const selectBankAccounts = (state: State) =>
  state.bankAccounts.bankAccounts;
export const selectSortParams = (state: State) => state.bankAccounts.sortParams;

export const getBankAccounts = createSelector(
  selectBankAccounts,
  selectSortParams,
  (bankAccounts, sortParams) => {
    const { order, orderBy, type } = sortParams;

    return _orderBy(
      bankAccounts,
      (ba) => orderByType(get(ba, orderBy), type),
      order || 'asc'
    );
  }
);
